import arriereBackoffice, {
  BackOfficePrivilegeName,
} from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { trackError } from '@tracking/customEventReport'

export const getUserPermissions = () => {
  return arriereBackoffice.queries.me
    .raw({
      __alias: 'getUserPermissions',
      id: true,
      email: true,
      roles: { id: true, name: true },
      // NOTE: `privileges { name }` is deliberately NOT selected. It was never
      // read (permissions come from groupedPrivileges below), and because
      // BackOfficeUser.privileges and BackOfficePrivilege.name are both
      // non-nullable, a single privilege the server can't map to the enum
      // nulls the whole `me` object and locks the user out of the app.
      groupedPrivileges: {
        privileges: {
          actionKinds: {
            action: true,
            id: true,
          },
        },
      },
    })
    .then(({ data, errors }) => {
      if (errors?.length) {
        trackError('Attempt to get user permissions', { errors })
        throw new Error(errors[0]?.message)
      }

      localStorage.setItem('user_email', data.email)

      const userPermissions = data.groupedPrivileges.reduce(
        (accPermissions: BackOfficePrivilegeName[], currentPermission) => {
          const { privileges } = currentPermission
          const groupActionKinds = privileges.map(permission => permission.actionKinds).flat()
          const allPermissionsForGroup = groupActionKinds.map(permission => permission.id)

          return [...accPermissions, ...allPermissionsForGroup]
        },
        [],
      )

      return {
        voyageId: data.id,
        userPermissions,
        roles: data.roles,
      }
    })
}
